import type { DataGridFilterState, DataGridSortingState, TableFilterState, TableSortingState } from '@ibsys/kit';
import { fromDataGridFilterValue, toDataGridFilterValue } from '@/shared/lib';

/**
 * Конвертирует фильтры из формата персистенции в формат DataGrid. Признак заполненности едет
 * оператором отбора, прочие значения — конвертом; незаданное значение остаётся пустым конвертом.
 */
export const toDataGridFilters = (filters: TableFilterState): DataGridFilterState =>
  Object.fromEntries(filters.map(({ id, value }) => [id, toDataGridFilterValue(value) ?? { value: undefined }]));

/** Конвертирует фильтры из формата DataGrid в формат персистенции */
export const fromDataGridFilters = (filters: DataGridFilterState): TableFilterState =>
  Object.entries(filters).map(([id, filter]) => ({ id, value: fromDataGridFilterValue(filter) }));

/** Конвертирует сортировку из формата персистенции в формат DataGrid */
export const toDataGridSorting = (sorting: TableSortingState): DataGridSortingState =>
  sorting.map(({ id, desc }) => ({ columnId: id, direction: desc ? ('desc' as const) : ('asc' as const) }));

/** Конвертирует сортировку из формата DataGrid в формат персистенции */
export const fromDataGridSorting = (sorting: DataGridSortingState): TableSortingState =>
  sorting.map(({ columnId, direction }) => ({ id: columnId, desc: direction === 'desc' }));
